import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  getCompanyLogo,
} from "../../../utils/utils.common";
import { sweetAlert } from "../../../utils/swal";
import { downloadBase64File } from "../../../utils/pdf-downloader";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { FleetService } from "../fleet-service/fleet.service";
import { CsvService } from "../../../service/csv-service/csv.service";
import * as _ from 'underscore';
import * as moment from 'moment-timezone';
import { EquipmentService } from "../../equipments/equipment-service/equipment.service";
import { StaffService } from "../../staffs/staff-service/staff.service";
import { ServiceAreasService } from "../../service-areas/service-areas-service/service-areas.service";
import { SharedDataService } from "../../../service/shared-service/shared-data.service";
@Component({
  selector: "app-fleet-list",
  templateUrl: "./fleet-list.component.html",
  styleUrls: ["./fleet-list.component.css"],
})
export class FleetListComponent implements OnInit, OnDestroy {
  path = null;
  fleetList = [];
  equipments =[];
  search: any;
  status = "active";
  filteredFleetList = [];
  selectedStationManager = [];
  stationManagerList = [];
  preStaffList = {};
  selectedServiceArea = [];
  filteredServiceAreas = [];
  preServiceAreas = {};
  timeZone: string = '';

  constructor(
    private equipmentService: EquipmentService,
    private fleetService: FleetService,
    private staffService: StaffService,
    private serviceArea: ServiceAreasService,
    private csvService: CsvService,
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit() {
    this.getUser();
    this.getEquipments();
    this.getFleetList();
    this.getStaffList();
    this.getServiceAreas();
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.timeZone = data.timeZone;
        }
      });
  }

  getFleetList() {
    this.fleetService
      .getFleetList({'isFleetSection': true,'status': this.status})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.selectedStationManager = [];
            this.fleetList = data;
            this.filteredFleetList = data;
            this.fleetList.forEach((fleet)=>{
              if (fleet.driver && fleet.driver.stationManager) {
                this.stationManagerList.push(fleet.driver.stationManager)
              }

              this.stationManagerList = _.uniq(this.stationManagerList).sort();

              this.filterFleet();
            })
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "OK");
        }
      );
  }

  onChangeStatus() {
    this. getFleetList()
  }

  getCompanyImage(driverCar) {
    return getCompanyLogo(driverCar);
  }

  downloadSingleFleetQR(fleetId) {
    this.fleetService.getSingleFleetQR(fleetId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  downloadAllFleetQR() {
    const data = {
      status: this.path,
    };
    this.fleetService.getAllFleetQR(data)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          downloadBase64File(data.content, data.pdfName);
        }
      },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
    );
  }

  downloadCSV() {
    const data = {
      date: moment().tz(this.timeZone).format("MM-DD-YYYY"),
      fleetList: this.filteredFleetList,
      preStaffList: this.preStaffList,
      preServiceAreas: this.preServiceAreas,
      timezone: this.timeZone
    };
    this.csvService.generateFleetReport(data);
  }
  
  getServiceAreas() {
    this.serviceArea.getServiceAreas({ status: 'active' })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.filteredServiceAreas = data
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
  }

  getEquipments() {
    let queryParam = {
      isAddon: false
    }
      this.equipmentService
        .getEquipments(queryParam)
        .subscribe(data => {
          if (data && data.length) {
            this.equipments = data;
          }else{
            this.equipments = [];
          }
        }, err => {
          sweetAlert("Error", err, "error", "Ok");
        });
  }

  filterFleet() {


    this.filteredFleetList = this.fleetList.filter((fleet) => {
      const serviceAreaMatch = this.selectedServiceArea.length === 0 ||
        fleet.serviceAreas.some(area => this.selectedServiceArea.includes(area));

      const stationManagerMatch = this.selectedStationManager.length === 0 ||
        (fleet.driver && this.selectedStationManager.includes(fleet.driver.stationManager));

      return stationManagerMatch && serviceAreaMatch;
    });
  }

  getStaffList() {
    let queryParams = {
      status: 'active'
    }
    this.staffService
      .getStaffList(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preStaffList = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  ngOnDestroy(): void {
  }
}
